/// <reference path="../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Services;
    (function (Services) {
        var BaseHttpService = /** @class */ (function () {
            function BaseHttpService(httpService) {
                this.httpService = httpService;
            }
            /**
             * This is the POST method used to create data on the server
             * @param url - The URL for the server call
             * @param data - The request object used to create the requested object
             * @param isFormData - A value indicating that the data passed for creation is in FormData format
             * @param localStorageKey - The local storage key used for caching the request data
             * @param bustCache - A value indicating that local storage should be reset and call to server should complete regardless
             * @returns { An object that matches your type ReturnType promise - NOTE void is an acceptable type when making this request }
             */
            BaseHttpService.prototype.create = function (url, data, isFormData, localStorageKey, bustCache) {
                return this.httpService.create(url, data, isFormData, localStorageKey, bustCache);
            };
            /**
             * This is the DELETE method used to delete/remove data from the server
             * @param url - The URL for the server call
             * @param localStorageKey - The local storage key used for caching the request data
             * @returns { An object that matches your type ReturnType promise - NOTE void is an acceptable type when making this request }
             */
            BaseHttpService.prototype.delete = function (url, localStorageKey) {
                return this.httpService.delete(url, localStorageKey);
            };
            BaseHttpService.prototype.enableTimeStampedUrl = function (value) {
                this.httpService.enableTimeStampedUrl(value);
            };
            /**
             * This is the Get method used to retrieve your data from the server
             * @param url - The URL for the server call
             * @param data - The object used to filter the requested result object
             * @param localStorageKey - The local storage key for the requested object.
             * @param bustCache - A value indicating that local storage should be reset and call to server should complete regardless
             * @returns { An object that matches your type ReturnType promise }
             */
            BaseHttpService.prototype.get = function (url, data, localStorageKey, bustCache) {
                return this.httpService.get(url, data, localStorageKey, bustCache);
            };
            /**
             * This should ONLY be used for the renewing of the access token as it will delay all other http requests until it has completed.
             * @param url - The authentication data SSO API renewal endpoint
             * @param data - The data object required for renewing the authentication data token
             */
            BaseHttpService.prototype.renew = function (url, data) {
                return this.httpService.renew(url, data);
            };
            /**
             * This will return an ng.IPromise of Type ReturnType based on the specified variable.  If no variable is passed the promise will be void
             * @param object - The object that should be resolved with the promise.then()
             * @returns { The exact object specified wrapped in a ng.IPromise }
             */
            BaseHttpService.prototype.resolveDeferred = function (object) {
                return this.httpService.resolveDeferred(object);
            };
            /**
             * This is the PUT method used to update data on the server
             * @param url - The URL for the server call
             * @param data - The object containing the ALL values for the object being updated
             * @param isFormData - A value indicating that the data passed for creation is in FormData format
             * @returns { An object that matches your type ReturnType promise - NOTE void is an acceptable type when making this request }
             */
            BaseHttpService.prototype.update = function (url, data, isFormData) {
                return this.httpService.update(url, data, isFormData);
            };
            return BaseHttpService;
        }());
        Services.BaseHttpService = BaseHttpService;
        angular.module('app.Services')
            .service('baseHttpService', BaseHttpService);
    })(Services = app.Services || (app.Services = {}));
})(app || (app = {}));
